import { evaluateRouteRedirect } from '../utils';
import { authService } from '../../services';
import { IS_HOYA_THEME, IS_SEIKO_THEME } from '../../branding';

const redirectIfDifferentBrand = ( routePath ) => () => {
    const isAuthenticated = authService.isAuthenticated();
    if ( isAuthenticated ) {
        const userTags = authService.getTags() || [];

        const violatesHoya = ( IS_HOYA_THEME && !userTags.includes( 'ishoyalearningcenteruser' ) );
        const violatesSeiko = ( IS_SEIKO_THEME && !userTags.includes( 'isseikoacademyuser' ) );

        // At the moment, users (specifically Azure users) might not have a Person
        // Attribute suggesting the brand/company they belong to. If the user doesn't
        // have permission to either at the moment, allow them to access the route.
        // 
        // TODO: Revisit this logic. Should probably adjust and reconsider.
        if ( violatesHoya && violatesSeiko ) {
            return undefined;
        }
    
        if ( violatesHoya || violatesSeiko ) {
            return evaluateRouteRedirect( routePath );
        }
        
        return undefined;
    }
    else {
        // If the user is not authenticated, we don't know which brand they belong to,
        // so don't do anything.
        return undefined;
    }
};

export default redirectIfDifferentBrand;
